import { Chip } from '@mui/material';
import { StorefrontOutlined } from '@mui/icons-material';
import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { useRefinementList } from 'react-instantsearch';
import useNormalizedCurrentRefinements from '../../hooks/useNormalizedCurrentRefinements';
import { brandsAtom } from '../../brands/state';

export default function BrandTags(): React.JSX.Element {
  const { refine } = useRefinementList({ attribute: 'brand' });
  const currentBrands = useNormalizedCurrentRefinements('brand') as string[];
  const brands = useAtomValue(brandsAtom);

  const brandsMap = useMemo(() => {
    if (!brands.length) {
      return {};
    }

    return Object.fromEntries(brands.map((brand) => [brand.value, brand.comment]));
  }, [brands]);

  const brandTags = useMemo(() => {
    if (!brandsMap) {
      return;
    }

    return currentBrands.map((brand) => (
      <Chip
        variant="filter"
        icon={<StorefrontOutlined />}
        onDelete={() => refine(brand)}
        label={brandsMap[brand]}
        key={brand}
      />
    ));
  }, [currentBrands, brandsMap]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {brandTags}
    </>
  );
}
